import { render, staticRenderFns } from "./userMy_userAssetAttr.vue?vue&type=template&id=6996e95f&scoped=true"
import script from "./userMy_userAssetAttr.vue?vue&type=script&lang=js"
export * from "./userMy_userAssetAttr.vue?vue&type=script&lang=js"
import style0 from "./userMy_userAssetAttr.vue?vue&type=style&index=0&id=6996e95f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996e95f",
  null
  
)

component.options.__file = "userMy_userAssetAttr.vue"
export default component.exports